import { TextField } from "@material-ui/core";
import { useField } from "formik";
import React from "react";

const Input = ({ type, label, ...props }) => {
  const [field] = useField(props);

  return (
    <TextField
      type={type}
      {...field}
      margin="normal"
      variant="outlined"
      fullWidth
      label={label}
    />
  );
};

export default Input;
